import { useEffect, useState } from 'react'
import { Spin } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import ModelDialog from '@/components/ModelDialog'
import { getPools } from '@/api/pool'
import { useFeedback } from '@/utils/antdApp'
import type { StockPool } from '@/types'
import './index.scss'

interface Props {
    open: boolean
    currentPoolId: number | null
    onCancel: () => void
    onConfirm: (poolId: number, poolName: string) => void
}

export default function PoolSelectDialog({ open, currentPoolId, onCancel, onConfirm }: Props) {
    const { message } = useFeedback()
    const [pools, setPools] = useState<StockPool[]>([])
    const [loading, setLoading] = useState(false)
    const [selectedId, setSelectedId] = useState<number | null>(currentPoolId)

    useEffect(() => {
        if (!open) return
        setSelectedId(currentPoolId)
        setLoading(true)
        getPools()
            .then(data => setPools(data ?? []))
            .catch(() => message.error('加载股票池失败'))
            .finally(() => setLoading(false))
    }, [open])

    const handleConfirm = () => {
        const pool = pools.find(p => p.id === selectedId)
        if (!pool) { message.error('请选择一个股票池'); return }
        onConfirm(pool.id, pool.name)
    }

    return (
        <ModelDialog
            open={open}
            width={520}
            title="选择股票池"
            sureText="确认选择"
            onCancel={onCancel}
            onSure={handleConfirm}
        >
            {loading ? (
                <div className="psd__loading"><Spin /></div>
            ) : pools.length === 0 ? (
                <div className="psd__empty">暂无可用股票池</div>
            ) : (
                <div className="psd__list">
                    {pools.map(pool => {
                        const isSelected = pool.id === selectedId
                        return (
                            <div
                                key={pool.id}
                                className={`psd__card${isSelected ? ' is-selected' : ''}${!pool.count ? ' is-disabled' : ''}`}
                                onClick={() => pool.count && setSelectedId(pool.id)}
                            >
                                <div className="psd__card-main">
                                    <div className="psd__card-top">
                                        <span className="psd__card-name">{pool.name}</span>
                                        <span className="psd__card-count">{pool.count ?? 0} 只</span>
                                    </div>
                                    {pool.description ? (
                                        <div className="psd__card-desc">{pool.description}</div>
                                    ) : (
                                        <div className="psd__card-desc psd__card-desc--empty">暂无简介</div>
                                    )}
                                </div>
                                <div className={`psd__card-check${isSelected ? ' is-visible' : ''}`}>
                                    <CheckOutlined />
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
        </ModelDialog>
    )
}
